export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["سيؤدي هذا الإجراء إلى حذف الأصل نهائياً"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["هل أنت متأكد أنك تريد المتابعة؟"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["نعم"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إلغاء"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لن ترى هذا الأصل في قائمتك بعد الآن."])}
}